<div class="image">
  <img loading="eager" fill alt="logo" [src]="reviewItem.picture" />
</div>
<div class="content">
  <span class="title">{{ reviewItem.title }}</span>
  <p class="description">{{ reviewItem.description }}</p>
</div>
